import { defineMessages } from 'react-intl'

export const oversightScenarioMessages = defineMessages({
  addScenario: {
    defaultMessage: 'Add oversight scenario',
    description: 'oversight scenario create dialog header',
  },
  analyzersHelp: {
    defaultMessage:
      'Which analyzers run for sampled conversations. Empty = none run (fail-closed).',
    description: 'oversight scenario analyzers field help',
  },
  analyzersLabel: {
    defaultMessage: 'Analyzers',
    description: 'oversight scenario analyzers field label',
  },
  createSuccess: {
    defaultMessage: 'Oversight scenario created',
    description: 'oversight scenario create success notification',
  },
  disabledChip: {
    defaultMessage: 'Disabled',
    description: 'oversight scenario disabled chip',
  },
  emptyTable: {
    defaultMessage: 'No oversight scenarios yet',
    description: 'oversight scenario empty list',
  },
  enabledChip: {
    defaultMessage: 'Enabled',
    description: 'oversight scenario enabled chip',
  },
  enabledHelp: {
    defaultMessage: 'When off, oversight is disabled for every case using this scenario.',
    description: 'oversight scenario enabled field help',
  },
  enabledLabel: {
    defaultMessage: 'Enabled',
    description: 'oversight scenario field label',
  },
  headTitle: {
    defaultMessage: 'Scenario settings',
    description: 'oversight scenario detail head card title',
  },
  healthEveryNHelp: {
    defaultMessage: 'Run the conversation-health analyzer at most once per N inbound messages.',
    description: 'oversight scenario health cadence field help',
  },
  healthEveryNLabel: {
    defaultMessage: 'Health cadence (every N inbound)',
    description: 'oversight scenario health cadence field label',
  },
  healthMinIntervalMsHelp: {
    defaultMessage:
      'Minimum gap in milliseconds between conversation-health runs for one conversation.',
    description: 'oversight scenario health debounce field help',
  },
  healthMinIntervalMsLabel: {
    defaultMessage: 'Health debounce (ms)',
    description: 'oversight scenario health debounce field label',
  },
  maxCallsPerConvDayHelp: {
    defaultMessage: 'Hard cap on analyzer model calls per conversation per day (cost backstop).',
    description: 'oversight scenario daily budget field help',
  },
  maxCallsPerConvDayLabel: {
    defaultMessage: 'Max model calls / conversation / day',
    description: 'oversight scenario daily budget field label',
  },
  modelHelp: {
    defaultMessage:
      'Exact AI model the oversight analyzers call. Previews are listed and may be selected.',
    description: 'oversight scenario model field help',
  },
  modelLabel: {
    defaultMessage: 'Model',
    description: 'oversight scenario model field label',
  },
  nameHelp: {
    defaultMessage: 'A human-readable label, e.g. "Trainee QA — high sample".',
    description: 'oversight scenario name field help',
  },
  nameLabel: {
    defaultMessage: 'Name',
    description: 'oversight scenario field label',
  },
  sampleRateHelp: {
    defaultMessage:
      'Base percent of conversations analysed (0–100). The assignee multiplier scales this per case.',
    description: 'oversight scenario sample rate field help',
  },
  sampleRateLabel: {
    defaultMessage: 'Sample rate (%)',
    description: 'oversight scenario field label',
  },
})
